import axios from "axios";

const api = axios.create({
  baseURL: "https://emailreactapi2.linkext.co.in", // your API URL
});

export default api;